import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React, { useState, useEffect } from "react";
import { useMutation, useQuery } from "@apollo/client";
//import { useParams } from "react-router-dom";
import { Button } from "@mui/material";
import { ALL_LINKS, DELETE_LINK, LOCK_LINK } from "../queries";
// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/links/DesignBlocks";
//import Pages from "pages/Presentation/links/Pages";
//import Testimonials from "pages/Presentation/links/Testimonials";
//import Download from "pages/Presentation/links/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";

// Images
import bgImage from "assets/images/strategia.jpg";
import { useTranslation } from "react-i18next";
/* eslint-disable react/prop-types */
const Linksadmin = ({ setError }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  const [links, setLinks] = useState([]);
  const [t] = useTranslation("common");
  const linkss = useQuery(ALL_LINKS, {
    pollInterval: 1000000,
  });
  useEffect(() => {
    let linksss = [];
    //let municipalitiess = [];
    if (linkss.data) {
      linksss = linkss.data.allLinks;
      //setOrgans(organss);
      //console.log(linksss);
      setLinks(linksss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [linkss]);
  const [lockLink] = useMutation(LOCK_LINK, {
    refetchQueries: [{ query: ALL_LINKS }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });

  const [deleteLink] = useMutation(DELETE_LINK, {
    refetchQueries: [{ query: ALL_LINKS }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });
  const setLocked = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    lockLink({
      variables: { id: event, active: false },
    });
    //muutetaan activated !actived edituser
  };
  const setUnlocked = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    lockLink({
      variables: { id: event, active: true },
    });
    //muutetaan activated !actived edituser
  };

  const setDelete = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    deleteLink({
      variables: { id: event },
    });
    //muutetaan activated !actived edituser
  };
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 500px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      />
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="black"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Linkit Admin{" "}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="black"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              {links.map((lin) => (
                <div key={lin.id}>
                  <a href={lin.linkref} target="0">
                    {lin.linktext}
                  </a>
                  <br />
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    size="small"
                    type="submit"
                    onClick={() => setUnlocked(lin.id)}
                  >
                    {t("common.unlock")}
                  </Button>
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    size="small"
                    type="submit"
                    onClick={() => setLocked(lin.id)}
                  >
                    {t("common.lock")}
                  </Button>
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    size="small"
                    type="submit"
                    onClick={() => {
                      if (window.confirm("Haluatko varmasti poistaa linkin?")) {
                        setDelete(lin.id);
                      }
                    }}
                  >
                    {t("common.delete")}
                  </Button>
                  <br />
                </div>
              ))}
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
};

export default Linksadmin;
